export default __webpack_public_path__ + "static/media/dog-pink.989dca77.svg";